/* eslint-disable jsx-a11y/anchor-is-valid */
// Importação de componentes e React
import React, { useEffect, useState } from "react";

// importação de estilização
import style from "./bodyPeopleApresentacao.module.css";

// Importação de configuração manual
import localeText from "../../config/localeText";
import API_ROUTES from "../../utils/endpoints";
import api from "../../utils/api";

// Importação de biblioteca de terceiros
import axios from "axios";
import Papa from "papaparse";
import * as XLSX from "xlsx";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Button from "@mui/material/Button";
import { DataGrid } from "@mui/x-data-grid";
import * as locales from "@mui/material/locale";
import Typography from "@mui/material/Typography";
import { Drawer, IconButton, Input, List } from "@mui/material";
import { toast, ToastContainer } from "react-toastify";
import BodyModal from "../bodyModalAddOrEditUser/bodyModal";
import CircularProgress from "@mui/material/CircularProgress";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { createTheme, ThemeProvider, useTheme } from "@mui/material/styles";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import Swal from "sweetalert2";

import KeyboardReturnIcon from "@mui/icons-material/KeyboardReturn";

import SmartphoneIcon from "@mui/icons-material/Smartphone";

function BodyPeopleBodyApresentacao() {
  // constante de input de dados
  const [confirmateDelete, setConfirmateDelete] = useState("");

  const [nivel, setNivel] = useState("4");
  const [people, setPeople] = useState([]);
  const [usuario, setUsuario] = useState([]);
  const [bodyResquest, setBodyRequest] = useState({});

  const [pageMockup, setPageMockup] = useState("Estrutura");
  const [templates, setTemplates] = useState({});
  const [templateSelected, setTemplateSelected] = useState({});

  // constante de manipulação de elementos
  const [loading, setLoading] = useState(true);
  const [openModalAdd, setOpenModalAdd] = useState(false);
  const [openModalEdit, setOpenModalEdit] = useState(false);
  const [openModalDelete, setOpenModalDelete] = useState(false);
  const [errorBodyRequest, setErrorBodyRequest] = useState(false);
  const [confirmateDeleteOK, setConfirmateDeleteOK] = useState(false);

  const [state, setState] = React.useState(false);

  // constante de linguagem do datagrid
  const theme = useTheme();

  // constantes de estilização de componente
  const pageSize = 50;
  const deleteIconStyle = { color: "red", width: "1vw" };
  const editIconStyle = { color: "#510EA5", width: "1vw" };

  // Função abrir modal de deletar usuario
  const handleOpenModalDelete = (user) => {
    setOpenModalDelete(true);
    setUsuario(user);
  };

  // FUnção fecha modal de deletar usuário
  const handleClose = () => {
    setOpenModalDelete(false);
    setUsuario([]);
  };

  // Função abrir modal de editar usuario
  const handleOpenModalEdit = (user) => {
    setOpenModalEdit(true);
    setUsuario(user);
  };

  // Função de fechar modal de editar usuario
  const handleCloseEdit = () => {
    setOpenModalEdit(false);
    setUsuario([]);
  };

  // Função abrir modal de adicionar usuario
  const handleOpenModalAdd = () => {
    setOpenModalAdd(true);
  };

  // Função de fechar modal de adicionar usuario
  const handleCloseAdd = () => {
    setOpenModalAdd(false);
  };

  // Confirmação de texto "Confirmar"
  const handleConfirmText = (value) => {
    setConfirmateDeleteOK(false);
    setConfirmateDelete(value.target.value);
  };

  const handleChangePageToNivel = (value) => {
    setPageMockup(value);
  };

  // notificação de sucesso
  const notifySucess = (text) => toast.success(text);

  // Validador de objeto vazio
  function isEmpty(obj) {
    return Object.values(obj).length === 0;
  }

  const exportToCSV = (data, columns) => {
    // Filtrar colunas relevantes para exportação
    const exportableColumns = columns.filter((col) => !col.renderCell);

    // Mapear cabeçalhos das colunas
    const headers = exportableColumns.map((col) => col.headerName);

    // Mapear dados das linhas
    const rows = data.map((row) =>
      exportableColumns.map((col) => row[col.field]),
    );

    // Criar a string CSV
    const csv = Papa.unparse([headers, ...rows]);

    // Criar um elemento de link para baixar o arquivo
    const link = document.createElement("a");
    link.href = "data:text/csv;charset=utf-8," + encodeURI(csv);
    link.target = "_blank";
    link.download = "data.csv";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const exportToXLSX = (data, columns) => {
    // Filtrar colunas relevantes para exportação
    const exportableColumns = columns.filter((col) => !col.renderCell);

    // Mapeamento dos dados para o formato necessário
    const exportData = data.map((row) => {
      let rowData = {};
      exportableColumns.forEach((col) => {
        rowData[col.headerName] = row[col.field];
      });
      return rowData;
    });

    // Criar uma worksheet a partir dos dados
    const worksheet = XLSX.utils.json_to_sheet(exportData);

    // Criar uma workbook e adicionar a worksheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Gerar e salvar o arquivo Excel
    XLSX.writeFile(workbook, "data.xlsx");
  };

  const handleChangeTeste = () => {
    setState(true);
    setPageMockup("Estrutura");
  };

  const dateToday = () => {
    const date = new Date();
    let dia = date.getDate().toString();
    let mes = (date.getMonth() + 1).toString();
    let ano = date.getFullYear().toString();
    let hora = date.getHours().toString();
    let min = date.getMinutes().toString();

    return `${dia.padStart(2, "0")}/${mes.padStart(
      2,
      "0",
    )}/${ano} ${hora.padStart(2, "0")}:${min.padStart(2, "0")}`;
  };

  const handleChangeInvitateMessage = async () => {
    const obj = {
      acionador: "tester",
      data: dateToday(),
      nivel: `N${nivel}`,
      nameTemplate: templateSelected.template_name,
    };

    await axios
      .post(API_ROUTES.POST_MESSAGE, obj)
      .then((res) => {
        setPageMockup("Estrutura");
        setState(false);
        notifySucess("Mensagem enviada com sucesso!");
      })
      .catch((err) => {
        console.log(err);
      });
  };

  // Confirmação de Criação de Usuario
  const handleCreateUser = async () => {
    try {
      const { data } = await api.post(API_ROUTES.POST_USER_MNT, bodyResquest);
      if (data.codigo && data.codigo === 200) {
        fetchPeople();
        Swal.fire({
          icon: "success",
          title: "Sucesso",
          text: "Usuário inserido com sucesso!",
          toast: true,
          showConfirmButton: false,
          position: "top-right",
        });
      } else {
        Swal.fire({
          icon: "error",
          text: "Não foi possível realizar o cadastro do usuário.",
          title: "Erro ao inserir usuário",
          toast: true,
          showConfirmButton: false,
          position: "top-right",
        });
      }
    } catch (e) {
      Swal.fire({
        icon: "error",
        text: "Não foi possível realizar o cadastro do usuário.",
        title: "Erro ao inserir usuário",
        toast: true,
        showConfirmButton: false,
        position: "top-right",
      });
    }
  };

  // Confirmação de alteração de usuario
  const handleAlternateUser = async () => {
    if (!isEmpty(bodyResquest)) {
      try {
        const { data } = await api.put(
          API_ROUTES.PUT_USER_MNT(usuario.usuario, usuario.email),
          bodyResquest,
        );
        if (data.codigo && data.codigo === 200) {
          fetchPeople();
          handleCloseEdit();
          Swal.fire({
            icon: "success",
            title: "Sucesso",
            text: "Usuário inserido com sucesso!",
            toast: true,
            showConfirmButton: false,
            position: "top-right",
          });
        } else {
          Swal.fire({
            icon: "error",
            text: "Não foi possível realizar o cadastro do usuário.",
            title: "Erro ao inserir usuário",
            toast: true,
            showConfirmButton: false,
            position: "top-right",
          });
        }
      } catch (e) {
        Swal.fire({
          icon: "error",
          text: "Não foi possível realizar o cadastro do usuário.",
          title: "Erro ao inserir usuário",
          toast: true,
          showConfirmButton: false,
          position: "top-right",
        });
      }
    } else {
      setErrorBodyRequest(true);
    }
  };

  useEffect(() => {
    console.log(templateSelected);
  }, [templateSelected]);

  const Lista = () => (
    <Box sx={{ width: "30vw" }} role="presentation">
      <List>
        <div className={style["main-smartphone"]}>
          <div className={style["title-smartphone"]}>SIMULAÇÃO</div>

          <div className={style["imagemMokcup"]}>
            {pageMockup === "Estrutura" ? (
              <div className={style["background-mockup"]}>
                <div className={style["title"]}>Escolha Uma Estrutura</div>
                <div
                  className={style["layer"]}
                  onClick={() => handleChangePageToNivel("LVL")}
                >
                  <div className={style["option-mina"]}>MINA DE TESTE</div>
                </div>
              </div>
            ) : pageMockup === "LVL" ? (
              <div className={style["background-mockup"]}>
                <div style={{ display: "flex", flexDirection: "row" }}>
                  <div
                    onClick={() => setPageMockup("Estrutura")}
                    style={{ cursor: "pointer" }}
                  >
                    {" "}
                    <KeyboardReturnIcon
                      sx={{ width: "1.25vw", color: "#303030" }}
                    />
                  </div>
                  <div className={style["title"]}>Escolha Um Nível</div>
                </div>
                <div className={style["layer-mina"]}>
                  <div
                    className={style["level1"]}
                    onClick={() => {
                      setNivel("1");
                    }}
                  >
                    Nivel 1
                  </div>
                  <div
                    className={style["level2"]}
                    onClick={() => {
                      setNivel("2");
                    }}
                  >
                    Nivel 2
                  </div>
                  <div
                    className={style["level3"]}
                    onClick={() => {
                      setNivel("3");
                    }}
                  >
                    Nivel 3
                  </div>
                  <div
                    className={style["teste"]}
                    onClick={() => {
                      setNivel("5");
                    }}
                  >
                    Teste
                  </div>
                </div>
              </div>
            ) : (
              <div className={style["background-mockup"]}>
                <div style={{ display: "flex", flexDirection: "row" }}>
                  <div
                    onClick={() => setPageMockup("LVL")}
                    style={{ cursor: "pointer" }}
                  >
                    {" "}
                    <KeyboardReturnIcon
                      sx={{ width: "1.25vw", color: "#303030" }}
                    />
                  </div>
                  <div className={style["title"]}>Mensagem de envio</div>
                </div>
                <div
                  className={style["layer-mina"]}
                  onClick={() => handleChangePageToNivel("DefinirAlerta")}
                >
                  <select
                    onChange={(event) => {
                      setTemplateSelected(JSON.parse(event.target.value));
                    }}
                    value={JSON.stringify(templateSelected)}
                  >
                    <option value="" defaultChecked>
                      Selecione uma mensagem
                    </option>
                    {templates.map((data, i) => (
                      <option value={JSON.stringify(data)} key={i}>
                        {data.template_desc}
                      </option>
                    ))}
                  </select>
                  <textarea
                    className={style["input-mensagem"]}
                    value={templateSelected.template_content}
                  ></textarea>

                  <button
                    className={style["button-envio-mensagem"]}
                    onClick={() => handleChangeInvitateMessage()}
                  >
                    ENVIAR MENSAGEM
                  </button>
                </div>
              </div>
            )}
          </div>

          <a onClick={() => setState(false)} style={{ color: "red" }}>
            Cancelar Teste
          </a>
        </div>
      </List>
    </Box>
  );

  // Confirmação de deleção de Usuário
  const handleConfirmDelete = async () => {
    if (confirmateDelete.toLowerCase() === "confirmar") {
      try {
        const { data } = await api.delete(
          API_ROUTES.DELETE_USER_MNT(usuario.usuario, usuario.email),
        );
        if (data.codigo) {
          handleClose();
          fetchPeople();
          Swal.fire({
            icon: "success",
            title: "Sucesso",
            text: "Usuário deletado com sucesso!",
            toast: true,
            showConfirmButton: false,
            position: "top-right",
          });
        } else {
          Swal.fire({
            icon: "error",
            text: "Não foi possível realizar a deleção do usuário.",
            title: "Erro ao deletar usuário",
            toast: true,
            showConfirmButton: false,
            position: "top-right",
          });
        }
      } catch (err) {
        Swal.fire({
          icon: "error",
          text: "Não foi possível realizar a deleção do usuário.",
          title: "Erro ao deletar usuário",
          toast: true,
          showConfirmButton: false,
          position: "top-right",
        });
      }
    } else {
      setConfirmateDeleteOK(true);
    }
  };

  // Função que captura usuarios do banco
  const fetchPeople = async () => {
    try {
      const { data } = await api.get(API_ROUTES.GET_USER_ALL_MNT);
      const mappedData = data.map((person, index) => {
        const gruposTraduzidos = person.nivel?.map((nivel) => {
          if (nivel === "N4") return "SIMULADO";
          if (nivel === "N5") return "EFNI";
          return nivel; // mantém os outros níveis como estão
        });
        return {
          id: index,
          name: person.contact_info.name,
          email: person.contact_info.email,
          telefone: person.contact_info.phone,
          usuario: person.username,

          grupo: gruposTraduzidos,
          funcao: person.sector.function,
          typeUser: person.sector.hierarchy,
          niveis: person.nivel,
          typeUserData:
            person.sector.hierarchy === "0"
              ? "Administrador"
              : person.sector.hierarchy === "1"
                ? "Interno"
                : "Externo",
          icons: {
            person: <EditOutlinedIcon />,
            delete: <DeleteOutlineOutlinedIcon />,
          },
          password: person.password,
        };
      });
      setPeople(mappedData);
      setLoading(false);
    } catch (error) {
      console.error("Erro ao buscar pessoas:", error);
      setLoading(false); // Mesmo em caso de erro, marca o carregamento como concluído
    }
  };

  const fetchTemplate = async () => {
    try {
      const { data } = await api.get(API_ROUTES.GET_TEMPLATE_BARREIRA(nivel));
      setTemplates(data.templates);
    } catch (e) {
      console.log(e);
    }
  };

  // Captura usuarios do banco
  useEffect(() => {
    fetchPeople();
  }, []);

  useEffect(() => {
    setPageMockup("DefinirAlerta");
    fetchTemplate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nivel]);

  // Colunas do datagrid
  const columns = [
    {
      field: "icons",
      headerName: "",
      width: 1,
      renderCell: (params) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
          }}
        >
          <IconButton onClick={() => handleOpenModalEdit(params.row)}>
            <EditOutlinedIcon sx={editIconStyle} />{" "}
            {/* Aplica o estilo de cor azul */}
          </IconButton>
        </div>
      ),
    },
    {
      field: "deleteIcon",
      headerName: "",
      width: 1,
      renderCell: (params) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
          }}
        >
          <IconButton onClick={() => handleOpenModalDelete(params.row)}>
            <DeleteOutlineOutlinedIcon sx={deleteIconStyle} />{" "}
            {/* Aplica o estilo de cor vermelha */}
          </IconButton>
        </div>
      ),
    },
    { field: "name", headerName: "Nome", width: 200 },
    { field: "email", headerName: "Email", width: 250 },
    { field: "telefone", headerName: "Telefone", width: 250 },
    { field: "usuario", headerName: "Usuário", width: 250 },
    { field: "typeUserData", headerName: "Tipo Usuário", width: 250 },
    { field: "grupo", headerName: "Grupo", width: 250 },
    { field: "funcao", headerName: "Função", width: 250 },
  ];

  // Tradução do datagrid
  const themeWithLocale = React.useMemo(
    () => createTheme(theme, locales["ptBR"]),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    ["ptBR", theme],
  );

  // Estilização do modal
  const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    height: confirmateDeleteOK ? 350 : 300,
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
    borderRadius: "8px", // Bordas arredondadas
    textAlign: "center", // Alinhamento do texto
  };

  // Estilizador do modal de edição de usuario / adição de usuario
  const modalStyleAddOrEditUser = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "60vw",
    height: "90%",
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
    borderRadius: "8px", // Bordas arredondadas
    textAlign: "center", // Alinhamento do texto
    overflowY: "scroll",
    scrollbarWidth: "none", // Oculta a barra de rolagem no Firefox
    "&::-webkit-scrollbar": {
      display: "none", // Oculta a barra de rolagem no Chrome, Safari e Edge
    },
  };

  useEffect(() => {
    setErrorBodyRequest(false);
  }, [bodyResquest]);

  return (
    <div className={style["App"]}>
      {/* Modal de Excluir Usuario */}
      <Modal
        open={openModalDelete}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={modalStyle}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Deseja realmente <strong>remover</strong> o usuário {usuario.name}?
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            Caso sim, digite <a>CONFIRMAR</a>
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            para realizar o processo.
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 4 }}>
            <Input
              className={style["inputConfirmation"]}
              onChange={(value) => handleConfirmText(value)}
            ></Input>
          </Typography>

          {confirmateDeleteOK ? (
            <Typography id="modal-modal-description" sx={{ mt: 7 }}>
              <p style={{ color: "red" }}>
                Para realizar o processo digite 'Confirmar' corretamente.
              </p>
            </Typography>
          ) : null}

          <Typography id="modal-modal-description" sx={{ mt: 7.5 }}>
            <div className={style["buttons"]}>
              <Button
                variant="contained"
                style={{ marginRight: 15 }}
                onClick={() => handleConfirmDelete()}
              >
                CONFIRMAR
              </Button>
              <Button
                variant="contained"
                color="error"
                onClick={() => handleClose()}
              >
                CANCELAR
              </Button>
            </div>
          </Typography>
        </Box>
      </Modal>

      {/* Modal de Editar Usuario */}
      <Modal
        open={openModalEdit}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={modalStyleAddOrEditUser}>
          <div>
            <BodyModal
              usuario={usuario ? usuario : "nada"}
              bodyRequest={(value) => setBodyRequest(value)}
            />

            <footer>
              <div className={style["buttons"]}>
                {errorBodyRequest ? (
                  <div>
                    <p>Verifique os campos obrigatórios e de confirmação</p>
                    <p>para realizar o processo de alteração!</p>
                  </div>
                ) : null}
                <Button
                  variant="contained"
                  style={{ marginRight: 15, marginLeft: 15 }}
                  onClick={() => handleAlternateUser()}
                >
                  Alterar
                </Button>
                <Button
                  variant="contained"
                  color="error"
                  onClick={() => handleCloseEdit()}
                >
                  CANCELAR
                </Button>
              </div>
            </footer>
          </div>
        </Box>
      </Modal>

      {/* Modal de Adicionar Usuario */}
      <Modal
        open={openModalAdd}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={modalStyleAddOrEditUser}>
          <div>
            <BodyModal
              usuario={""}
              bodyRequest={(value) => setBodyRequest(value)}
            />

            <footer>
              <div className={style["buttons"]}>
                {errorBodyRequest ? (
                  <div>
                    <p>Verifique os campos obrigatórios e de confirmação</p>
                    <p>para realizar o processo de alteração!</p>
                  </div>
                ) : null}
                <Button
                  variant="contained"
                  style={{ marginRight: 15, marginLeft: 15 }}
                  onClick={() => handleCreateUser()}
                >
                  Cadastrar
                </Button>
                <Button
                  variant="contained"
                  color="error"
                  onClick={() => handleCloseAdd()}
                >
                  CANCELAR
                </Button>
              </div>
            </footer>
          </div>
        </Box>
      </Modal>

      {/* Drawer Right */}
      <React.Fragment>
        <Drawer open={state} anchor="right">
          <Lista />
        </Drawer>
      </React.Fragment>

      {/* Renderização de Datagrid */}
      {!loading && (
        <div className={style["container-grid"]}>
          <Box>
            <div style={{ width: "100%", display: "flex" }}>
              <Button
                variant="contained"
                style={{
                  backgroundColor: "#B8ABF8",
                  margin: "1vw",
                  borderRadius: "0.5vw",
                  width: "12.5vw",
                  fontSize: "0.75vw",
                  height: "4vh",
                }}
                onClick={() => handleOpenModalAdd()}
              >
                <AddCircleOutlineIcon
                  style={{ marginRight: "0.45vw", width: "1vw" }}
                />{" "}
                Adicionar Usuário
              </Button>
              <Button
                variant="contained"
                style={{
                  margin: "1vw",
                  backgroundColor: "#DDD6FD",
                  borderRadius: "0.5vw",
                  width: "12.5vw",
                  fontSize: "0.75vw",
                  height: "4vh",
                  color: "black",
                }}
                onClick={() => exportToCSV(people, columns)}
              >
                <FileDownloadOutlinedIcon
                  style={{ marginRight: "0.5vw", width: "1vw" }}
                />{" "}
                Exportar CSV
              </Button>
              <Button
                variant="contained"
                style={{
                  margin: "1vw",
                  backgroundColor: "#DDD6FD",
                  borderRadius: "0.5vw",
                  width: "12.5vw",
                  fontSize: "0.75vw",
                  height: "4vh",
                  color: "black",
                }}
                onClick={() => exportToXLSX(people, columns)}
              >
                <FileDownloadOutlinedIcon
                  style={{ marginRight: "0.5vw", width: "1vw" }}
                />{" "}
                Exportar XLSX
              </Button>

              <Button
                variant="contained"
                style={{
                  backgroundColor: "#505050",
                  margin: "1vw",
                  borderRadius: "0.5vw",
                  width: "12.5vw",
                  fontSize: "0.75vw",
                  height: "4vh",
                }}
                onClick={() => handleChangeTeste()}
              >
                <SmartphoneIcon style={{ marginRight: "15%", width: "1vw" }} />{" "}
                Realizar Teste
              </Button>
            </div>
            <ThemeProvider theme={themeWithLocale}>
              <DataGrid
                sx={{
                  width: "87.5vw",
                  height: "84.9vh",
                  backgroundColor: "white",
                  fontSize: "0.7vw",
                }}
                rows={people}
                columns={columns}
                localeText={localeText}
                pageSize={pageSize}
                paginationMode="client"
                pagination={true}
                location={"ptBR"}
                initialState={{
                  pagination: {
                    paginationModel: {
                      pageSize: 50,
                    },
                  },
                }}
              />
            </ThemeProvider>
          </Box>
        </div>
      )}

      {/* Renderização de Carregamento de pagina */}
      {loading && (
        <Box
          sx={{
            display: "flex",
            width: "100%",
            height: "100%",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <CircularProgress />
        </Box>
      )}
      <ToastContainer />
    </div>
  );
}

export default BodyPeopleBodyApresentacao;
